<template lang="pug">
router-view
</template>

<script>
export default {
  metaInfo() {
    const { seoTitle, seoDescription, seoKeywords } =
      this.$store.state.regionProfile;
    // В случае невозможной загрузки шрифтов из серфиса https://fonts.google.com
    // путь в href: заменить на этот — /site_assets/css/google-local-fonts.css
    // всё это лежит в папке /static/
    return {
      title: seoTitle,
      link: [
        {
          rel: 'stylesheet',
          href: '/site_assets/css/google-local-fonts.css',
          type: 'text/css',
        },
      ],
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            seoKeywords || 'блог, цопп, профессиональная, подготовка, центр',
        },
        {
          name: 'viewport',
          content:
            'width=device-width, initial-scale=1, maximum-scale=1, minimal-ui',
        },
      ],
    };
  },
};
</script>

<style>
* {
  /*position: relative;*/
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  cursor: default;
  font-family: sans-serif;
  -webkit-tap-highlight-color: transparent;
  -webkit-focus-ring-color: rgba(255, 255, 255, 0);
  zoom: 102%; /* !!! */
}

body {
  /*overflow-x: visible !important;*/
  font-size: 100%;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Roboto', sans-serif;
  overflow-y: auto;
  color: rgba(0, 0, 0, 0.85);
  background-color: #ddd;
  overflow-x: hidden;
  max-height: 100%
}

body,
html {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Root.vue?09d0110c